import React from 'react';
import { motion } from 'framer-motion';
interface FinalCTAProps {
  onOpenModal: () => void;
}
export function FinalCTA({
  onOpenModal
}: FinalCTAProps) {
  return <section className="py-32 relative overflow-hidden" data-id="element-80">
      {/* Glowing Dashboard Background */}
      <div className="absolute inset-0 opacity-20 pointer-events-none" data-id="element-81">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[600px] bg-accent/20 blur-[150px] rounded-full" data-id="element-82" />
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4wNSkiLz48L3N2Zz4=')] [mask-image:linear-gradient(to_bottom,white,transparent)]" data-id="element-83" />
      </div>

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-84">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-5xl md:text-7xl font-bold tracking-tight mb-8 text-gradient" data-id="element-85">
          Stop looking everywhere.
          <br data-id="element-86" />
          Start seeing everything.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-lg md:text-xl text-textSecondary mb-12 max-w-xl mx-auto" data-id="element-87">
          <p data-id="element-88">Your answers are already there. We'll help you see them.</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-89">
          <button onClick={onOpenModal} className="w-full sm:w-auto bg-white text-black font-medium px-8 py-4 rounded-full hover:bg-white/90 transition-colors text-lg" data-id="element-90">
            Build My Dashboard
          </button>
          <button onClick={onOpenModal} className="w-full sm:w-auto glass-panel text-white font-medium px-8 py-4 rounded-full hover:bg-white/5 transition-colors text-lg" data-id="element-91">
            Book a Strategy Call
          </button>
        </motion.div>
      </div>
    </section>;
}